import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import LiveDashBoardOpsPlannerMap from "./LiveDashBoardOpsPlannerMap";
import "./ProjectDetailsMaps.css";
const ProjectDetailsMaps = ({ addressDetails = [], addressDirections = [], isRefreshedLayout, selectedAddress, siteOffset, siteTimezone }) => {
    const coordinates = {
        lat: [],
        lng: []
    };
    addressDetails.forEach((details) => {
        coordinates.lat.push(Number(details.location[0]));
        coordinates.lng.push(Number(details.location[1]));
    });
    const averageLng = (Math.max(...coordinates.lng) + Math.min(...coordinates.lng)) / 2;
    const averageLat = (Math.max(...coordinates.lat) + Math.min(...coordinates.lat)) / 2;
    const mapCenter = useMemo(() => ({ lat: averageLat, lng: averageLng }), [averageLat, averageLng]);
    return (_jsx("div", { "data-test": "map-section", children: _jsx(LiveDashBoardOpsPlannerMap, { addressDetails: addressDetails, addressDirections: addressDirections, isRefreshedLayout: isRefreshedLayout, mapCenter: mapCenter, selectedAddress: selectedAddress, siteOffset: siteOffset, siteTimezone: siteTimezone }) }));
};
export default ProjectDetailsMaps;
